import { useEffect } from 'react';
import { Button, notification } from 'antd';
import { CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const Alert = ({ subscriptionStatus, message, formattedMessage, daysRemaining, endDate }) => {

    const [api, contextHolder] = notification.useNotification();
    useEffect(() => {
        if (subscriptionStatus === 'no_subscription' || subscriptionStatus === 'active') {
            return;
        }

        const appWrapper = document.querySelector('.app-wrapper');
        if (appWrapper) {
            appWrapper.classList.add('blur');
        }

        // Open Antd notification
        const key = `alert-${Date.now()}`; // Unique key for the notification
        api.open({
            key,
            message: (
                <span style={{ fontWeight: 'bold', color: '#000000', fontSize: '18px' }}>
                    {message || 'Subscription Alert'}
                </span>
            ),
            description: (
                <div>
                    <p style={{ color: '#000000', fontSize: '16px' }}>
                        {formattedMessage || 'Your subscription requires attention.'}
                    </p>
                    {(daysRemaining !== undefined && endDate) && (
                        <div className="text-gray-600 text-sm mt-2 space-y-1">
                            {daysRemaining !== undefined && (
                                    <p style={{fontWeight:"bold", display:"flex", alignItems:"center", gap:"5px", fontSize:"1rem"}}>
                                        Days Remaining: <span>{daysRemaining}</span>
                                    </p>
                            )}
                            {endDate && (
                                    <p style={{fontWeight:"bold", display:"flex", alignItems:"center", gap:"5px", fontSize:"1rem"}}>
                                        End Date: <span>{new Date(endDate).toLocaleDateString()}</span>
                                    </p>
                            )}
                        </div>
                    )}
                    {subscriptionStatus === 'expiring_this_month' ? (
                        <Button
                            type="primary"
                            onClick={() => api.destroy(key)}
                            style={{ marginTop: '12px', backgroundColor: '#00ff00', borderColor: '#00ff00' }}
                        >
                            Close
                        </Button>
                    ) : (
                        <Button
                            type="primary"
                            onClick={() => api.destroy(key)}
                            style={{ marginTop: '12px', backgroundColor: '#ff0000', borderColor: '#ff0000' }}
                        >
                            Close
                        </Button>
                    )}
                </div>
            ),
            icon: subscriptionStatus ==='expiring_this_month' ? <ExclamationCircleOutlined style={{ color: '#00ff00', fontSize: '24px' }} /> : <ExclamationCircleOutlined style={{ color: '#ff0000', fontSize: '24px' }} />, // Red icon with pulsate animation
            duration: 100000,
            style: {
                transition: 'opacity 1s ease-out', // Smooth fade-out over 1s
                padding: '2rem',
                border: subscriptionStatus === 'expiring_this_month' ? '2px solid #00ff00' : '2px solid #ff0000',
                borderRadius: '8px',
            },
            role: 'alert',
            onClose: () => {
                if (appWrapper) {
                    appWrapper.classList.remove('blur');
                }
            },
        });

        // Cleanup: Close notification when component unmounts
        return () => {
            api.destroy(key);
            if (appWrapper) {
                appWrapper.classList.remove('blur');
            }
        };
    }, [subscriptionStatus, message, formattedMessage, daysRemaining, endDate]);

    return <>{contextHolder}</>;
};

export default Alert;